import { StockTransactionDoneSummary } from '../stock-transaction/StockTransactionDoneSummary';

interface DoneSummaryCardProps {
  selectedStock: string;
  defaultExpanded?: boolean;
  isActive?: boolean;
}

export function DoneSummaryCard({ selectedStock, defaultExpanded = false, isActive = true }: DoneSummaryCardProps) {
  const overflowGuardClasses = 'w-full max-w-full overflow-x-auto md:overflow-x-visible';
  const shrinkWrapClasses = 'min-w-0 [&_*]:min-w-0';

  return (
    <div className="bg-card rounded border border-border overflow-hidden h-full flex flex-col">
      <div className={`p-0 flex-1 overflow-y-auto ${overflowGuardClasses}`}>
        <div className={shrinkWrapClasses}>
          <div className="space-y-4">
            <StockTransactionDoneSummary 
              selectedStock={selectedStock} 
              disableTickerSelection={true} 
              isDashboard={true} 
              isActive={isActive} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

